import { db } from '../lib/firebase';
import { doc, getDoc, setDoc, arrayUnion, arrayRemove } from 'firebase/firestore';

export interface UserPreferences {
  preferredCategories: string[];
}

export interface SavedSearch {
  query: string;
  categories: string[];
}

export async function getUserPreferences(uid: string): Promise<UserPreferences> {
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    const data = snap.data() as any;
    return {
      preferredCategories: Array.isArray(data.preferredCategories) ? data.preferredCategories : [],
    };
  }
  return { preferredCategories: [] };
}

export async function updateUserPreferences(uid: string, prefs: Partial<UserPreferences>): Promise<void> {
  const ref = doc(db, 'users', uid);
  await setDoc(ref, {
    preferredCategories: prefs.preferredCategories ?? [],
  }, { merge: true });
}

export async function getUserUniversity(uid: string): Promise<string | null> {
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    const data = snap.data() as any;
    return typeof data.university === 'string' ? data.university : null;
  }
  return null;
}

export async function updateUserUniversity(uid: string, university: string): Promise<void> {
  const ref = doc(db, 'users', uid);
  await setDoc(ref, { university }, { merge: true });
}

export async function getSavedSearches(uid: string): Promise<SavedSearch[]> {
  const ref = doc(db, 'users', uid);
  const snap = await getDoc(ref);
  if (snap.exists()) {
    const data = snap.data() as any;
    const saved = Array.isArray(data.savedSearches) ? data.savedSearches : [];
    // Normalize entries to our interface
    return saved.map((s: any) => ({
      query: typeof s?.query === 'string' ? s.query : '',
      categories: Array.isArray(s?.categories) ? s.categories : [],
    }));
  }
  return [];
}

export async function addSavedSearch(uid: string, search: SavedSearch): Promise<void> {
  const ref = doc(db, 'users', uid);
  await setDoc(ref, { savedSearches: arrayUnion(search) }, { merge: true });
}

export async function removeSavedSearch(uid: string, search: SavedSearch): Promise<void> {
  const ref = doc(db, 'users', uid);
  await setDoc(ref, { savedSearches: arrayRemove(search) }, { merge: true });
}